import { AccountModal } from '../AccountModal/AccountModal';
import { DownForMaintenanceModal } from '../DownForMaintenanceModal/DownForMaintenanceModal';
import { MobileOverlay } from '../MobileOverlay/MobileOverlay';
import { OnboardModals } from '../Onboard/OnboardModals';
import { PnlCardModal } from '../PnlCardModal/PnlCardModal';
import { SettingsModal } from '../SettingsModal/SettingsModal';
import { WalletBlockedModal } from '../WalletBlockedModal/WalletBlockedModal';

export const RootModals = () => (
  <>
    <MobileOverlay />
    <OnboardModals />
    <SettingsModal />
    <WalletBlockedModal />
    <DownForMaintenanceModal />
    <PnlCardModal />
    <AccountModal />
  </>
);
